import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-base-cron',
  templateUrl: './base-cron.component.html',
  styleUrls: ['./base-cron.component.scss'],
})
export class BaseCronComponent implements OnInit {
  text: string;
  weekdays = [
    { label: 'Monday', value: 'Monday' },
    { label: 'Tuesday', value: 'Tuesday' },
    { label: 'Wednesday', value: 'Wednesday' },
    { label: 'Thursday', value: 'Thursday' },
    { label: 'Friday', value: 'Friday' },
    { label: 'Saturday', value: 'Saturday' },
    { label: 'Sunday', value: 'Sunday' },
  ];
  months = [
    { label: 'January', value: 'January' },
    { label: 'February', value: 'February' },
    { label: 'March', value: 'March' },
    { label: 'April', value: 'April' },
    { label: 'May', value: 'May' },
    { label: 'June', value: 'June' },
    { label: 'July', value: 'July' },
    { label: 'August', value: 'August' },
    { label: 'September', value: 'September' },
    { label: 'October', value: 'October' },
    { label: 'November', value: 'November' },
    { label: 'December', value: 'December' },
  ];
  formGroup: FormGroup;
  mon: any;
  monNum: any;
  time: string;
  yrNum: any;
  yrMon: any;
  weeklyTime: any;
  weeklyDay: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      selectedButton: new FormControl('minutely'),
      minutely: new FormControl(0),
      hourly: new FormControl(0),
      daily: new FormControl(0),
      weekly: new FormControl(0),
      weeklyMon: new FormControl(0),
      monthly: new FormControl(0),
      monthlyNum: new FormControl(0),
      yearlyTime: new FormControl(0),
      yearlyNum: new FormControl(0),
      yearlyMon: new FormControl(0),
    });

    this.formGroup.controls.selectedButton.valueChanges.subscribe((s) => {
      this.getPeakTime(s);
    });
    this.attachListners();
  }

  onClick(selectedButton: string) {
    this.formGroup.reset();
    this.formGroup.patchValue({ selectedButton: selectedButton });
  }
  getPeakTime(selectedButton: string) {
    switch (selectedButton) {
      case 'minutely':
        this.formGroup.controls.minutely.valueChanges.subscribe((wef) => {
          this.text = 'Every ' + wef + ' minutes';
        });
        break;
      case 'Hourly':
        this.formGroup.controls.hourly.valueChanges.subscribe((wef) => {
          this.text = 'Every ' + wef + ' minutes past the hour';
        });
        break;
      case 'Daily':
        this.formGroup.controls.daily.valueChanges.subscribe((wef) => {
          this.text = 'At ' + wef;
        });
        break;
      case 'Weekly':
        this.text = 'At ' + this.weeklyTime + ' ,Only on' + this.weeklyDay;
        break;
      case 'Monthly':
        this.text = 'Every ' + this.mon + ' ,on day ' + this.monNum;
        break;
      case 'Yearly':
        this.text =
          'Every ' +
          this.time +
          ' ,on day ' +
          this.yrNum +
          ' of month, Only in ' +
          this.yrMon;
        break;
      default:
        this.text = '';
        break;
    }
  }

  attachListners() {
    this.formGroup.controls.weekly.valueChanges.subscribe((wef) => {
      this.weeklyTime = wef;
      this.setMonthlyText(wef, this.formGroup.get('weekly').value, '');
    });
    this.formGroup.controls.weeklyMon.valueChanges.subscribe((wef) => {
      this.weeklyDay = wef;
      this.setMonthlyText(wef, this.formGroup.get('weeklyMon').value, '');
    });

    this.formGroup.controls.monthly.valueChanges.subscribe((wef) => {
      this.mon = wef;
      this.setMonthlyText(wef, this.formGroup.get('monthly').value, '');
    });
    this.formGroup.controls.monthlyNum.valueChanges.subscribe((wef) => {
      this.monNum = wef;
      this.setMonthlyText(this.formGroup.get('monthlyNum').value, wef, '');
    });

    this.formGroup.controls.yearlyTime.valueChanges.subscribe((wef) => {
      this.time = wef;
      this.setMonthlyText(wef, this.formGroup.get('yearlyTime').value, '');
    });
    this.formGroup.controls.yearlyNum.valueChanges.subscribe((wef) => {
      this.yrNum = wef;
      this.setMonthlyText(this.formGroup.get('yearlyNum').value, wef, '');
    });
    this.formGroup.controls.yearlyMon.valueChanges.subscribe((wef) => {
      this.yrMon = wef;
      this.setMonthlyText(
        this.formGroup.get('yearlyTime').value,
        this.formGroup.get('yearlyNum').value,
        wef
      );
    });
  }

  setMonthlyText(t1, t2, t3) {
    if (t1 === this.formGroup.get('weekly').value) {
      this.text = 'Every ' + t1 + ', on day ' + this.weeklyDay;
    } else if (t2 === this.formGroup.get('weeklyMon').value) {
      this.text = 'Every ' + this.weeklyTime + ', on day ' + t2;
    }

    if (t1 === this.formGroup.get('monthly').value) {
      this.text = 'Every ' + t1 + ', on day ' + this.monNum;
    } else if (t2 === this.formGroup.get('monthlyNum').value) {
      this.text = 'Every ' + this.mon + ', on day ' + t2;
    }

    if (t1 === this.formGroup.get('yearlyTime').value) {
      this.text =
        'Every ' +
        t1 +
        ', on day ' +
        this.yrNum +
        ' of month, Only in ' +
        this.yrMon;
    } else if (t2 === this.formGroup.get('yearlyNum').value) {
      this.text =
        'Every ' +
        this.time +
        ', on day ' +
        t2 +
        ' of month, Only in ' +
        this.yrMon;
    } else if (t3 === this.formGroup.get('yearlyMon').value) {
      this.text =
        'Every ' +
        this.time +
        ', on day ' +
        this.yrNum +
        ' of month, Only in ' +
        t3;
    }
  }
}
